/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type {
  ValidationContext,
  ValidationRule,
  ValidationRuleSet,
} from '@ecsper/speciality-contract';

const sotRequired: ValidationRule = {
  id: 'sot-required',
  description: { 'en-GB': 'Statement of Truth content control is required' },
  severity: 'error',
  validate: (ctx: ValidationContext) => {
    const sotKeys = Object.keys(ctx.contentControls).filter((k) => k.startsWith('ecsper:sot:'));
    if (sotKeys.length === 0) {
      return {
        ruleId: 'sot-required',
        message: { 'en-GB': 'No Statement of Truth found. Insert one before saving.' },
        severity: 'error',
      };
    }
    const allFilled = sotKeys.every((k) => Boolean(ctx.contentControls[k]?.trim()));
    if (!allFilled) {
      return {
        ruleId: 'sot-required',
        message: { 'en-GB': 'Statement of Truth is empty.' },
        severity: 'error',
      };
    }
    return null;
  },
};

const declarationRequired: ValidationRule = {
  id: 'declaration-required',
  description: { 'en-GB': 'CPR Part 35 declaration content control is required' },
  severity: 'error',
  validate: (ctx: ValidationContext) => {
    const value = ctx.contentControls['ecsper:declaration'];
    if (!value || !value.trim()) {
      return {
        ruleId: 'declaration-required',
        message: { 'en-GB': 'CPR Part 35 declaration is missing or empty.' },
        severity: 'error',
      };
    }
    return null;
  },
};

export const expertWitnessValidationRules: ValidationRuleSet = {
  rules: [sotRequired, declarationRequired],
};
